<template>
  <div class="hm-container">
    <div class="container-header" v-if="showHeader">
      <slot name="header"></slot>
    </div>
    <div
      class="container-body"
      :class="{ transparent: bgTransparent, 'no-padding': noPadding }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    bgTransparent: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.container-header {
  background: #fff;
  padding: 18px;
  margin-bottom: 10px;
  width: calc(100% - 36px);
}

.container-body {
  background: #fff;
  padding: 18px;
  width: calc(100% - 36px);
  &.transparent {
    background: transparent;
  }
  &.no-padding {
    padding: 0;
    width: 100%;
  }
}
</style>
